import React from "react";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";
import { Typography } from "@material-ui/core";
import styled from "styled-components";
import LoginPage from "./components/LoginPage";
import CineFanSection from "./components/cinefan/CineFanSection";
import HKNTSection from "./components/hknt/HKNTSection";
import { Slide, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import HKIFFSection from "./components/hkiff/HKIFFSection";
import HKIFFAppSection from "./components/hkiff-app/HKIFFAppSection";
import PermissionProvider from "./util/PermissionProvider";

const StyledToastContainer = styled(ToastContainer).attrs({})`
  .Toastify__toast--dark {
    background-color: #323232;
  }
`;

function App(props) {
  return (
    <Typography>
      <Switch>
        <Route path="/login" component={LoginPage} />
        <PermissionProvider>
          <Switch>
            <Route path="/cinefan" component={CineFanSection} />
            <Route path="/hkiff" component={HKIFFSection} />
            <Route path="/hkiff-app" component={HKIFFAppSection} />
            <Route path="/hknt" component={HKNTSection} />
            <Route render={() => <Redirect to="/cinefan" />} />
          </Switch>
        </PermissionProvider>
      </Switch>
      <StyledToastContainer
        position="bottom-center"
        transition={Slide}
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover
      />
    </Typography>
  );
}

App.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default App;
